import React from 'react';
import { classes } from './withErrorMessage.st.css';
export const withErrorMessage = (Component) => (props) => {
    var _a;
    const errorMessageId = props.invalidMessage
        ? `${props.id || ((_a = props.field) === null || _a === void 0 ? void 0 : _a.externalId)}-error-message`
        : undefined;
    return (React.createElement(React.Fragment, null,
        React.createElement(Component, Object.assign({}, props, { errorMessageId: errorMessageId })),
        props.invalidMessage ? (React.createElement("div", { id: errorMessageId, className: classes.error }, props.invalidMessage)) : null));
};
export default withErrorMessage;
//# sourceMappingURL=withErrorMessage.js.map